export enum ApplicationStatusType {
    None = 0,
    Pending = 1,
    Submitted = 2,
    Cancelled = 3,
    Approved = 4,
    Rejected = 5,
    Requested = 6,
    SPRequest = 7,
    SPConfirmation = 8,
    AllocateTechnician = 9,
    TechnicianConfirmation = 10,
    Dispatched = 11,
    Delivered = 12,
    DeliveryFailed = 13,
    DispatchPending = 14,
    VumatelOrderPending = 15,
    VumatelOrderSubmitted = 16,
    VumatelOrderApproved = 17,
    VumatelOrderRejected = 18,
    VumatelOrderApplicationPending = 19,
    DeviceAllocated = 20,
    VumatelOrderCompleted = 21,
    ConnectionInitiated = 22,
    Resubmitted = 23,
    ResubmitPending = 24,
    VumatelActivationPending = 25,
    VumatelActivationCompleted = 26,
    NewCancellationRequest = 27,
    CancellationPending = 28,
    CancellationCompleted = 29,
    CancellationWithNotice = 30,
    CancellationRejected = 31,
    ServiceUpgradeRequest = 32,
    ServiceDowngradeRequest = 33,
    ServiceUpgradePending = 34,
    ServiceDowngradePending = 35,
    ServiceUpgradeCompleted = 36,
    ServiceDowngradeCompleted = 37,
    ServiceUpgradeCancelled = 38,
    ServiceDowngradeCancelled = 39,
    NewRequest = 40,
    WaitingConsignment = 41,
    Consigned = 42,
    WaitingOnDelivery = 43,
    ToCancel = 44,
    RainCancelled = 45,
    RainDelivered = 46,
    Deleted = 47,
    Suspended = 48,
    Restore = 49,
    CancelLTE = 50,
    Cancel = 51,
    UnconfirmedDelivery = 52,
    CancelledReason = 53,
    TransferPending = 54,
    TransferCompleted = 55,
    NewTransfer = 56,
    AccountTransferResubmitted = 57,
    AccountTransferIncomplete = 58,
    DeviceAllocateCancelled = 59,
    OrderProcessing = 60,
    PendingActivation = 61,
    ReceiveOwnershipRequested = 62,
    ReceiveOwnershipConfirmed = 63,
    ReceiveOwnershipRejected = 64,
    Resubmit = 65,
    AwaitingOrderProcessing = 66,
    OrderRejectedCancelledbyISP = 67,
    OrderRejectedCancelledbyResident = 68,
    OrderRejectedDuplicate = 69,
    OrderRejectedOutsideCoverage = 70,
    AwaitingISPApplication = 71,
    AwaitingNetworkCompletion = 72,
    AwaitingScheduling = 73,
    SchedulingAttempted = 74,
    InstallationScheduled = 75,
    InstallationInProgress = 76,
    InstallationComplete = 77,
    InstallationRejected = 78,
    AwaitingISPConfiguration = 79,
    Complete = 80,
    AwaitingAPIResponse = 81,
    VumatelOrderCancelledbyHomeConnect = 82,
    PendingOrderCreation = 83,
    OrderValidation = 84,
    PendingISPApplication = 85,
    ISPApplicationInProgress = 86,
    SiteSurveyPending = 87,
    AwaitingFeedbackFromClient = 88,
    InstallationSchedulePending = 89,
    SplicingInProgress = 90,
    PendingONTDiscovery = 91,
    PendingAutoConfiguration = 92,
    AutoConfigurationFailed = 93,
    Closed = 94,
    AEXRejected = 95,
    Abandoned = 96,
    NetworkNotReady = 97,
    New = 98,
    PendingNetworkCoverage = 99,
    PendingLandownerConsent = 100,
    PendingAccessBuild = 101,
    Production = 102,
    OctotelCancelled = 103,
    Archived = 104,
    OctotelCompleted = 105,
    Installed = 106,
    AwaitingProvisioning = 107,
    AwaitingRescheduling = 108,
    InstalledPreLive = 109,
    ManualReview = 110,
    NewOrderBeingProcessed = 111,
    OrderAcceptedVettingInProgress = 112,
    ISPAcceptedPendingLinkAfricaFeasability = 113,
    ScheduleBuild = 114,
    Build = 115,
    SplicingOrTesting = 116,
    Layer2InstallationComplete = 117,
    TOCComplete = 118,
    Layer2ConfigurationPending = 119,
    PendingISPActivation = 120,
    ISPActivationComplete = 121,
    LinkAfricaCancellation = 122,
    ISPRejected = 123,
    RejectedLinkNotViable = 124,
    NewTransferRequest = 125,
    NewTransferRequestApplicationPending = 126,
    RoadblockLandownerConsent = 127,
    SPSuspended = 128,
    AwaitingReconnect = 129,
    AwaitingMigration = 130,
    OrderRejected = 131,
    ISPAcceptedPendingDNATelFeasability = 132,
    DNATelCancellation = 133,
    Layer1InstallationComplete = 134,
    Layer1ConfigurationPending = 135,
    DNATelFeasibility = 136,
    AwaitingActivation = 137,
    ServiceActivated = 138,
    ActivationFailed = 139,
    AwaitingSchedulingAttempt = 140,
    AttemptingtoSchedule = 141,
    InstallationCompleted = 151,
    ActiveWithAnotherISP = 155,
    WaitingForPremiseCreation = 156,
    CancellationRequested = 157,
    DocumentPending = 161,
    DispatchFailed = 162,
    IncorrectAddress = 163,
    CollectionPending = 164,
    // Insufficientdocuments=165,
    // Holdforcollection=166,
    // ClientRefusedDelivery=167,
    // DownPaymentPending=168,
    // EFTPaymentSuccessful=169,
    PaymentPending = 165,
    PaymentCompleted = 166,
    OnlinePaymentCompleted = 167,
    OrderAcknowledged = 168,
    OrderInProgress = 169,
    OrderCompleted = 170

}

export enum CountryType {
    SouthAfrica = 1,
}
